/* BTM Touch — T16 shared mobile interactions (BR-T_MOBILE_UX_SPEC_2026-07-19_v1).
   Progressive enhancement: nothing here is required to read or buy. No libraries.
   2026-07-19 fix: active-pill centering now scrolls ONLY the pill bar horizontally
   (container scrollTo) — the previous scrollIntoView could also scroll the PAGE
   vertically back to the pill bar mid-read, which yanked users to the top on the
   Go / Big Poppa model pages. */
(function () {
  'use strict';
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- S0: measure the sticky site header, publish its height ----------
     Consumed by sections/btm-acroback-model-detail.liquid's
     .btm-model-detail__anchor-wrap { top: var(--btm-sticky-header-h, 0px) } so the
     page's own sticky sub-nav sits below the site header instead of at top:0.
     Same measurement convention as btm-header-polish.liquid's setPanelTop()
     (.section-header bounding-rect bottom -> --btm-mega-top custom property). */
  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }
  function getHeaderHeight() {
    var header = document.querySelector('.section-header');
    return header ? Math.max(header.getBoundingClientRect().bottom, 0) : 0;
  }
  function publishHeaderHeight() {
    document.documentElement.style.setProperty('--btm-sticky-header-h', getHeaderHeight() + 'px');
  }

  /* ---------- G3: rail kit (edge fades + dots + one-time swipe hint) ---------- */
  var RAILS = [
    { sel: '.btm-ab-compare__table-wrap', items: 'thead th:not(:first-child)', always: true },
    { sel: '.btm-flycarian-overview__feature-carousel' },
    { sel: '.btm-flycarian-overview__gallery-track' },
    { sel: '.btm-model-detail__feature-grid', mobileOnly: true }
  ];
  var mobile = matchMedia('(max-width: 749px)');

  function enhanceRail(cfg) {
    var el = document.querySelector(cfg.sel);
    if (!el || el.hasAttribute('data-btm-rail')) return;
    if (cfg.mobileOnly && !mobile.matches) return;
    el.setAttribute('data-btm-rail', '');
    el.setAttribute('data-fade', '');
    var ticking = false;
    function ends() {
      ticking = false;
      var max = el.scrollWidth - el.clientWidth;
      el.toggleAttribute('data-at-start', el.scrollLeft <= 2);
      el.toggleAttribute('data-at-end', el.scrollLeft >= max - 2);
    }
    el.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(ends); }
    }, { passive: true });
    ends();

    var items = cfg.items ? el.querySelectorAll(cfg.items) : el.children;
    if (items.length > 1) {
      var tpl = document.getElementById('btm-rail-dots-tpl');
      if (tpl) {
        var frag = tpl.content.cloneNode(true);
        var dotsWrap = frag.querySelector('.btm-rail-dots');
        var live = frag.querySelector('.btm-rail-live');
        var dots = [];
        for (var i = 0; i < items.length; i++) {
          var d = document.createElement('button');
          d.type = 'button';
          d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          (function (idx) {
            d.addEventListener('click', function () {
              items[idx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
            });
          })(i);
          dotsWrap.appendChild(d);
          dots.push(d);
        }
        el.insertAdjacentElement('afterend', frag.children ? dotsWrap : dotsWrap);
        if (live) dotsWrap.insertAdjacentElement('afterend', live);
        function setActive(idx) {
          dots.forEach(function (d, j) { d.classList.toggle('is-active', j === idx); });
          if (live) live.textContent = 'Slide ' + (idx + 1) + ' of ' + dots.length;
        }
        setActive(0);
        el.addEventListener('scroll', function () {
          requestAnimationFrame(function () {
            var w = el.scrollWidth / items.length;
            setActive(Math.min(dots.length - 1, Math.round(el.scrollLeft / Math.max(1, w))));
          });
        }, { passive: true });
      }
    }

    if (!RM && 'IntersectionObserver' in window && !sessionStorage.getItem('btmSwipeHint')) {
      var hintIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting || sessionStorage.getItem('btmSwipeHint')) return;
          sessionStorage.setItem('btmSwipeHint', '1');
          hintIO.disconnect();
          try {
            el.scrollTo({ left: 24, behavior: 'smooth' });
            setTimeout(function () { el.scrollTo({ left: 0, behavior: 'smooth' }); }, 450);
          } catch (err) { /* older engines: skip hint */ }
        });
      }, { threshold: .6 });
      hintIO.observe(el);
    }
  }

  /* ---------- S2: pill-nav built from the page's existing jump nav ---------- */
  var pillState = null; /* { shell, wrap, targets } once built, so resize can reposition it */
  function positionPills() {
    if (!pillState) return;
    var offset = getHeaderHeight() + (pillState.wrap.offsetHeight || 0);
    pillState.shell.style.top = offset + 'px';
    var margin = offset + pillState.shell.offsetHeight + 8;
    pillState.targets.forEach(function (t) { t.el.style.scrollMarginTop = margin + 'px'; });
  }
  function buildPills() {
    if (matchMedia('(min-width: 990px)').matches) return;
    var shell = document.getElementById('btm-section-pills');
    if (!shell || shell.childElementCount) return;
    var nav = document.querySelector('.btm-model-detail__anchor') ||
              document.querySelector('.btm-component-detail__anchor') ||
              document.querySelector('.btm-flycarian-overview__jump') ||
              document.querySelector('.btm-training-overview__jump') ||
              document.querySelector('.btm-accessories-overview__jump');
    if (!nav) return;
    var links = Array.prototype.filter.call(nav.querySelectorAll('a[href*="#"]'), function (a) {
      return a.hash && document.querySelector(a.hash.replace(/([:.])/g, '\\$1'));
    });
    if (links.length < 2) return;
    var wrap = nav.closest('.btm-model-detail__anchor-wrap, .btm-component-detail__anchor-wrap') || nav;
    wrap.insertAdjacentElement('afterend', shell);
    var targets = [];
    links.forEach(function (a) {
      var p = document.createElement('a');
      p.href = a.hash;
      p.textContent = a.textContent.trim();
      shell.appendChild(p);
      var t = document.querySelector(a.hash.replace(/([:.])/g, '\\$1'));
      if (t) { targets.push({ el: t, pill: p }); }
    });
    shell.hidden = false;
    document.body.classList.add('btm-pills-active');
    pillState = { shell: shell, wrap: wrap, targets: targets };
    positionPills();
    if ('IntersectionObserver' in window) {
      var current = null;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          targets.forEach(function (t) {
            var on = t.el === e.target;
            if (on) current = t;
            t.pill.setAttribute('aria-current', on ? 'true' : 'false');
          });
          if (current && shell.scrollWidth > shell.clientWidth) {
            var sx = current.pill.offsetLeft - (shell.clientWidth / 2) + (current.pill.offsetWidth / 2);
            shell.scrollTo({ left: Math.max(0, sx), behavior: RM ? 'auto' : 'smooth' });
          }
        });
      }, { rootMargin: '-30% 0px -55% 0px' });
      targets.forEach(function (t) { io.observe(t.el); });
    }
  }

  /* ---------- S4.4: AcroBack overview mobile quick-bar ---------- */
  function buildQuickbar() {
    var route = document.querySelector('.btm-ab-route');
    if (!route || document.querySelector('.btm-quickbar')) return;
    var shopLink = document.querySelector('.btm-ab-route__card--link');
    if (!shopLink) return;
    var compareSection = document.querySelector('.btm-ab-compare__table-section');
    var bar = document.createElement('div');
    bar.className = 'btm-quickbar';
    var shop = document.createElement('a');
    shop.className = 'btm-quickbar__shop';
    shop.href = shopLink.href;
    shop.textContent = 'Shop Go';
    var cmp = document.createElement('a');
    cmp.className = 'btm-quickbar__compare';
    cmp.href = compareSection && compareSection.id ? '#' + compareSection.id : '#btm-ab-route-models';
    cmp.textContent = 'Compare';
    bar.appendChild(shop); bar.appendChild(cmp);
    document.body.appendChild(bar);
    var suppressed = false;
    function update() {
      bar.classList.toggle('is-visible', !suppressed && window.scrollY > 600);
    }
    window.addEventListener('scroll', update, { passive: true });
    var final = document.querySelector('.btm-ab-route__decision');
    if (final && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { suppressed = e.isIntersecting; update(); });
      }, { threshold: .2 }).observe(final);
    }
    update();
  }

  /* ---------- S3.1: homepage hero scroll cue ---------- */
  function buildScrollCue() {
    var hero = document.querySelector('.btm-home-hero');
    if (!hero || hero.querySelector('.btm-scroll-cue')) return;
    var cue = document.createElement('div');
    cue.className = 'btm-scroll-cue';
    cue.setAttribute('aria-hidden', 'true');
    hero.appendChild(cue);
    function hide() {
      cue.classList.add('is-hidden');
      window.removeEventListener('scroll', hide);
    }
    window.addEventListener('scroll', hide, { passive: true, once: true });
  }

  function init() {
    publishHeaderHeight();
    RAILS.forEach(enhanceRail);
    buildPills();
    buildQuickbar();
    buildScrollCue();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', publishHeaderHeight);

  var onHeaderResize = debounce(function () {
    publishHeaderHeight();
    positionPills();
  }, 120);
  window.addEventListener('resize', onHeaderResize);

  /* Header height also changes shape during the first ~scroll: the header
     starts in normal flow below the announcement bar, then becomes pinned
     at top:0 once scrolled past it — so the published height needs one more
     pass during scroll, not just at load/resize. rAF-throttled to match the
     ticking-flag pattern used by enhanceRail() above. */
  var headerScrollTicking = false;
  window.addEventListener('scroll', function () {
    if (headerScrollTicking) return;
    headerScrollTicking = true;
    requestAnimationFrame(function () {
      headerScrollTicking = false;
      publishHeaderHeight();
      positionPills();
    });
  }, { passive: true });
})();
